import { create } from "zustand";

type PropertySearchState = {
  searchTermsByClientId: Record<string, string>;
  setSearchTerm: (clientId: string, term: string) => void;
  clearSearchTerm: (clientId: string) => void;
};

export const usePropertySearchStore = create<PropertySearchState>((set) => ({
  searchTermsByClientId: {},
  setSearchTerm: (clientId, term) =>
    set((state) => ({
      searchTermsByClientId: {
        ...state.searchTermsByClientId,
        [clientId]: term,
      },
    })),
  clearSearchTerm: (clientId) =>
    set((state) => {
      const remainingTerms = { ...state.searchTermsByClientId };
      delete remainingTerms[clientId];
      return { searchTermsByClientId: remainingTerms };
    }),
}));
